module.exports = __webpack_public_path__ + "static/media/bronze-medal.387b3fc9.png";